import React from 'react'
import Header, { listImage } from '../../components/header/header'
import Layout from '../../core/layout/layout'
import HeaderOptions from '../../components/header-options/header-options'
import OfferItem from './components/offer-item/offer-item'
import styled from 'styled-components'
import FormSearchTour from './components/form-search-tour/form-search-tour'
import SectionTC from '../../components/section-tc/section-tc'
import FeatureItem from './components/feature-item/feature-item'
import { device } from '../../config/theme/breakpoints'
import AlertTC from '../../components/alert-tc/alert-tc'
import PaymentMethods from './components/payment-methods/payment-methods'
import { ExclamationCircle } from '@styled-icons/heroicons-outline'
import DestinyItem from './components/destiny-item/destiny-item'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CustomSlider from '../../components/custom-slider/custom-slider'
import { listDestinationsItem, listFeature, listOfferItem } from './data'

const BodyHeaderContainer = styled.div`
  color: white;
  text-align: center;
  width: 100%;
  padding: 80px 0 50px;

  > div span{
    font-size: 12px;
  }

  @media ${device.tablet}{
    padding: 120px 0 50px;
  }
`
const PreTitle = styled.h3`
  font-style: italic;
  margin-bottom: 10px;
  font-weight: lighter;
  text-transform: uppercase;
  margin: 0;
`
const Title = styled.h1`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 40px;
  text-transform: uppercase;
  position: relative;
  width: fit-content;
  margin: auto;
  padding-bottom: 5px;
`
const TitleBar = styled.div`
    width: 30px;
    height: 7px;
    background: ${p => p.theme.palette.secondary.main};
    position: absolute;
    right: 0;
    bottom: 0;
    border-radius: 6px 0 15px 6px;
    transform: skew(-30deg)
`
const SubTitle = styled.p`
  margin-top: 20px;
  margin-bottom: 30px;
  font-size: 12px;

  @media ${device.tablet}{
    margin-top: 40px;
    margin-bottom: 60px;
  }
`
const FeatureCustomClass = `
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  gap: 15px;
  padding-top: 5px;
  padding-bottom: 5px;

  @media ${device.mobileL}{
    justify-content: space-around;
  }
`

const Landing: React.FunctionComponent = () => {  
  const sliderOfferRef = React.useRef<Slider>(null);
  const sliderDestinityRef = React.useRef<Slider>(null);

  return (
    <Layout>
        <Header images={listImage}>
          <BodyHeaderContainer>
            <SectionTC hidden>
              <PreTitle>Viaja por el Perú</PreTitle>
              <Title>
                Con tarifas únicas
                <TitleBar />
              </Title>
              <SubTitle>Conoce nuestros destinos y ofertas</SubTitle>
              <FormSearchTour auto/>
              <span>Encuentra respuestas a todas tus preguntas sobre viajes relacionadas con la COVID-19 aquí</span>
            </SectionTC>
          </BodyHeaderContainer>
        </Header>
        <HeaderOptions>
          <SectionTC className={FeatureCustomClass}>
            {listFeature.map(feature => (
              <FeatureItem
                key={feature.id}
                icon={feature.icon}
                title={feature.title}
                subTitle={feature.subTitle}
                description={feature.description}
              />
            ))}
          </SectionTC>
        </HeaderOptions>
        <SectionTC>
          <PaymentMethods />
          <AlertTC icon={<ExclamationCircle />} title="Comunicado" backgroundBodyText='rgb(222, 34, 30, 2%)' description='Informamos a nuestros pasajeros que según las nuevas medidas del Gobierno (DS-030 2022), los niños mayores de 12 años deberán acreditar segunda dosis de vacuna y los mayores de 18 años haber recibido la tercera dosis contra la COVID-19. Caso contrario, deberán presentar una prueba molecular negativa no mayor a 48 horas, antes de realizar su viaje.'/>
        </SectionTC>
        <CustomSlider
          sliderRef={sliderOfferRef}
          preTitle='Principales destinos'
          title='Y promociones'
          size={listOfferItem.length}
          withIconRight
        >
          {listOfferItem.map(offer => (
            <div key={offer.id}>
              <OfferItem
                  tour={offer.tour}
                  price={offer.price}
                  title={offer.title}
                  subTitle={offer.subTitle}
                  image={offer.image}
                  to='proceso-venta'
                />
            </div>
          ))}
        </CustomSlider>
        <CustomSlider
          sliderRef={sliderDestinityRef}
          preTitle='La emoción de viajar'
          title='Destinos'
          size={listDestinationsItem.length}
          withIconLeft
        >
          {listDestinationsItem.map(destiny => (
            <div key={destiny.id}>
              <DestinyItem
                tour={destiny.tour}
                image={destiny.image}
                title={destiny.title}
                subTitle={destiny.subTitle}
                description={destiny.description}
              />
            </div>
          ))}
        </CustomSlider>
    </Layout>
  )
}

export default Landing